import moment from "moment";
import { useSelector } from "react-redux";
import { LoaderMessage } from "../../../../components/loaderMessage/loaderMessage";
import NarIngestionReUpload from "../../../../components/modals/narIngestionReUpload/narIngestionReUpload";
import NarIngestionUpload from "../../../../components/modals/narIngestionUpload/narIngestionUpload";
import { ModalId } from "../../../../enums/modalId";
import { RootState } from "../../../../redux/store/store";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../utils/stringModifications";
import GridCard from "./components/gridCard";
import Header from "./components/header";
import { useFetchGridInfo } from "./hooks/fetchGridInfo";
import { useNarIngestionModal } from "./hooks/useNarIngestionModal";
import { getLastDateOfMonth } from "./utils/getLastDay";

const NarConfigurationLayout = () => {
  const { data, loading } = useFetchGridInfo(10);
  const { handleCloseModal, metaData } = useNarIngestionModal();
  const { openedModalId } = useSelector((state: RootState) => state.modal);
  return (
    <>
      <div className="nar-configuration-layout flex h-full w-full flex-col gap-4 overflow-y-auto p-2">
        <Header />
        {loading ? (
          <div className="flex h-full w-full flex-row items-center justify-center gap-2">
            <LoaderMessage message="Loading NAR Ingestion Logs..." />
          </div>
        ) : (
          data.map((item) => {
            const createdOnFormatted = moment(item.created_at_time).format(
              "MM/DD/YYYY HH:mm",
            );

            return (
              <GridCard
                key={item.id}
                insurance={capitalizeWordsSeperatedByUnderScore(
                  item.payer_type,
                )}
                insurancePlan={capitalizeWordsSeperatedByUnderScore(
                  item.sub_type,
                )}
                createdOn={createdOnFormatted}
                expiryDates={getLastDateOfMonth(item.month, item.year)}
                status={item.status}
                processedCsvPath={item.processed_csv_path}
                outputFileName={item.output_file_name}
                payerType={item.payer_type}
                subType={item.sub_type}
                month={item.month}
                year={item.year}
                documentType={item.document_type}
                documentId={item.id}
                isRejected={item.is_rejected}
              />
            );
          })
        )}
      </div>
      {openedModalId === ModalId.NAR_INGESTION_UPLOAD_MODAL && (
        <NarIngestionUpload onClose={handleCloseModal} />
      )}
      {openedModalId === ModalId.NAR_INGESTION_RE_UPLOAD_MODAL && (
        <NarIngestionReUpload
          onClose={handleCloseModal}
          csv_path={metaData?.csv_path || ""}
        />
      )}
    </>
  );
};

export default NarConfigurationLayout;
